import { render, staticRenderFns } from "./AddFileDialog.vue?vue&type=template&id=bb4ea180&"
import script from "./AddFileDialog.vue?vue&type=script&lang=js&"
export * from "./AddFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports